/**
 * Created by mfr on 2017-03-07.
 *
 * These icon URLs are persisted verbatim into customer data
 * (PlanOrderStoreyFileRevision.FabricJsContent) when an annotation canvas is
 * saved and are resolved again on every later load, so they must outlive every
 * deploy. Keep them as stable, hash-free paths under /images/ (served verbatim
 * from app/assets/images) — never require() them through the bundler, which
 * emits content-hashed filenames that change between deploys.
 *
 * The icon set is append-only: changed artwork gets a new filename; never
 * change or delete the file behind an existing name, or previously saved
 * canvases will render differently or lose objects.
 * See desicions/2026-06-12_stable_plan_annotation_icon_urls.md.
 */

let DragSources = {},
    SourcesMeta = {},
    SourcesBathroom = {},
    SourcesIndoors = {},
    SourcesKitchen = {},
    SourcesMisc = {},
    SourcesOutdoors = {};

// Meta

SourcesMeta['Delete'] = '/images/plan-annotation/plan-annotation-symbol-delete.svg';
SourcesMeta['Arrow'] = '/images/plan-annotation/plan-annotation-symbol-arrow.svg';
SourcesMeta['Comment'] = '/images/plan-annotation/plan-annotation-symbol-comment.svg';

DragSources['Meta'] = SourcesMeta;

// Bathroom

SourcesBathroom['Bathtub'] = '/images/plan-annotation/Bathroom/Bathtub.svg';
SourcesBathroom['Bidet'] = '/images/plan-annotation/Bathroom/Bidet.svg';
SourcesBathroom['CornerBathtub'] = '/images/plan-annotation/Bathroom/Corner-bathtub.svg';
SourcesBathroom['DryerWasherPillar'] = '/images/plan-annotation/Bathroom/Dryer-washer-pillar.svg';
SourcesBathroom['DryerWasher'] = '/images/plan-annotation/Bathroom/Dryer-washer.svg';
SourcesBathroom['DryingCabinet'] = '/images/plan-annotation/Bathroom/Drying-cabinet.svg';
SourcesBathroom['DualSink'] = '/images/plan-annotation/Bathroom/Dual-sink.svg';
SourcesBathroom['ShowerCabinWall'] = '/images/plan-annotation/Bathroom/Shower-cabin-wall.svg';
SourcesBathroom['ShowerCabin'] = '/images/plan-annotation/Bathroom/Shower-cabin.svg';
SourcesBathroom['ShowerCabin2'] = '/images/plan-annotation/Bathroom/Shower-cabin2.svg';
SourcesBathroom['ShowerCabin3'] = '/images/plan-annotation/Bathroom/Shower-cabin3.svg';
SourcesBathroom['ShowerCurtain'] = '/images/plan-annotation/Bathroom/Shower-curtain.svg';
SourcesBathroom['ShowerHead'] = '/images/plan-annotation/Bathroom/Shower-head.svg';
SourcesBathroom['SinkCommodity'] = '/images/plan-annotation/Bathroom/Sink-commodity.svg';
SourcesBathroom['Sink'] = '/images/plan-annotation/Bathroom/Sink.svg';
SourcesBathroom['Toilet'] = '/images/plan-annotation/Bathroom/Toilet.svg';
SourcesBathroom['TowelDryer'] = '/images/plan-annotation/Bathroom/Towel-dryer.svg';
SourcesBathroom['Tumbler'] = '/images/plan-annotation/Bathroom/Tumbler.svg';
SourcesBathroom['Washer'] = '/images/plan-annotation/Bathroom/Washer.svg';

DragSources['Bathroom'] = SourcesBathroom;

// Indoors

SourcesIndoors['AtticHatch'] = '/images/plan-annotation/Indoors/Attic-hatch.svg';
SourcesIndoors['BoilerHeater'] = '/images/plan-annotation/Indoors/Boiler-heater.svg';
SourcesIndoors['Boiler'] = '/images/plan-annotation/Indoors/Boiler.svg';
SourcesIndoors['CentralVacuum'] = '/images/plan-annotation/Indoors/Central-vacuum.svg';
SourcesIndoors['CircularStairs'] = '/images/plan-annotation/Indoors/Circular-stairs.svg';
SourcesIndoors['DistrictHeating'] = '/images/plan-annotation/Indoors/District-heating.svg';
SourcesIndoors['DoorLeft'] = '/images/plan-annotation/Indoors/Door-Left.svg';
SourcesIndoors['DoorRight'] = '/images/plan-annotation/Indoors/Door-Right.svg';
SourcesIndoors['DualDoors'] = '/images/plan-annotation/Indoors/Dual-doors.svg';
SourcesIndoors['Electricity'] = '/images/plan-annotation/Indoors/Electricity.svg';
SourcesIndoors['Fireplace'] = '/images/plan-annotation/Indoors/Fireplace.svg';
SourcesIndoors['Fireplace2'] = '/images/plan-annotation/Indoors/Fireplace2.svg';
SourcesIndoors['Fireplace3'] = '/images/plan-annotation/Indoors/Fireplace3.svg';
SourcesIndoors['GeothermalHeater'] = '/images/plan-annotation/Indoors/Geothermal-heater.svg';
SourcesIndoors['HalfWall'] = '/images/plan-annotation/Indoors/Half-wall.svg';
SourcesIndoors['HatRack'] = '/images/plan-annotation/Indoors/Hat-rack.svg';
SourcesIndoors['LinenCupboard'] = '/images/plan-annotation/Indoors/Linen-cupboard.svg';
SourcesIndoors['Shelf'] = '/images/plan-annotation/Indoors/Shelf.svg';
SourcesIndoors['SkylightWindow'] = '/images/plan-annotation/Indoors/Skylight-window.svg';
SourcesIndoors['StairStep'] = '/images/plan-annotation/Indoors/Stair-step.svg';
SourcesIndoors['StairsLeft'] = '/images/plan-annotation/Indoors/Stairs-Left.svg';
SourcesIndoors['StairsRight'] = '/images/plan-annotation/Indoors/Stairs-Right.svg';
SourcesIndoors['Stairs'] = '/images/plan-annotation/Indoors/Stairs.svg';
SourcesIndoors['Stove'] = '/images/plan-annotation/Indoors/Stove.svg';
SourcesIndoors['TiledStove'] = '/images/plan-annotation/Indoors/Tiled-stove.svg';
SourcesIndoors['TiledStove2'] = '/images/plan-annotation/Indoors/Tiled-stove2.svg';
SourcesIndoors['WardrobeSlidingDoors'] =
    '/images/plan-annotation/Indoors/Wardrobe-sliding-doors.svg';
SourcesIndoors['Wardrobe'] = '/images/plan-annotation/Indoors/Wardrobe.svg';
SourcesIndoors['WaterHeater'] = '/images/plan-annotation/Indoors/Water-heater.svg';
SourcesIndoors['Window'] = '/images/plan-annotation/Indoors/Window.svg';

DragSources['Indoors'] = SourcesIndoors;

// Kitchen

SourcesKitchen['Cabinet'] = '/images/plan-annotation/Kitchen/Cabinet.svg';
SourcesKitchen['CleaningCabinet'] = '/images/plan-annotation/Kitchen/Cleaning-cabinet.svg';
SourcesKitchen['CookerHood'] = '/images/plan-annotation/Kitchen/Cooker-hood.svg';
SourcesKitchen['Counter'] = '/images/plan-annotation/Kitchen/Counter.svg';
SourcesKitchen['Dishwasher'] = '/images/plan-annotation/Kitchen/Dishwasher.svg';
SourcesKitchen['DoubleKitchenSink'] = '/images/plan-annotation/Kitchen/Double-kitchen-sink.svg';
SourcesKitchen['Freezer'] = '/images/plan-annotation/Kitchen/Freezer.svg';
SourcesKitchen['FridgeFreezer'] = '/images/plan-annotation/Kitchen/Fridge-Freezer.svg';
SourcesKitchen['Fridge'] = '/images/plan-annotation/Kitchen/Fridge.svg';
SourcesKitchen['HighCabinet'] = '/images/plan-annotation/Kitchen/High-cabinet.svg';
SourcesKitchen['KitchenCounterWithTopCabinet'] =
    '/images/plan-annotation/Kitchen/Kitchen-counter-with-top-cabinet.svg';
SourcesKitchen['KitchenIsland'] = '/images/plan-annotation/Kitchen/Kitchen-island.svg';
SourcesKitchen['Micro'] = '/images/plan-annotation/Kitchen/Micro.svg';
SourcesKitchen['OvenMicro'] = '/images/plan-annotation/Kitchen/Oven-Micro.svg';
SourcesKitchen['Oven'] = '/images/plan-annotation/Kitchen/Oven.svg';
SourcesKitchen['Pantry'] = '/images/plan-annotation/Kitchen/Pantry.svg';
SourcesKitchen['RoundKitchenSink'] = '/images/plan-annotation/Kitchen/Round-kitchen-sink.svg';
SourcesKitchen['SingleKitchenSink'] = '/images/plan-annotation/Kitchen/Single-kitchen-sink.svg';
SourcesKitchen['Stove'] = '/images/plan-annotation/Kitchen/Stove.svg';
SourcesKitchen['WineCooler'] = '/images/plan-annotation/Kitchen/Wine-cooler.svg';

DragSources['Kitchen'] = SourcesKitchen;

// Misc

SourcesMisc['Asphalt'] = '/images/plan-annotation/Misc/Asphalt.svg';
SourcesMisc['CountertopStove'] = '/images/plan-annotation/plan-annotation-symbol-stove.svg';
// SourcesMisc["CountertopStove"]          = require("../../assets/images/plan-annotation/Misc/Countertop-stove.svg");
SourcesMisc['DashedLines'] = '/images/plan-annotation/Misc/Dashed-lines.svg';
SourcesMisc['DoorOpening'] = '/images/plan-annotation/Misc/Door-opening.svg';
SourcesMisc['GlazedTiles'] = '/images/plan-annotation/Misc/Glazed-tiles.svg';
SourcesMisc['Grass'] = '/images/plan-annotation/Misc/Grass.svg';
SourcesMisc['Hedge'] = '/images/plan-annotation/Misc/Hedge.svg';
SourcesMisc['InductionStove'] = '/images/plan-annotation/Misc/Induction-stove.svg';
SourcesMisc['RoundBathtub'] = '/images/plan-annotation/Misc/Round-bathtub.svg';
SourcesMisc['RoundSink'] = '/images/plan-annotation/Misc/Round-sink.svg';
SourcesMisc['ShowerWall'] = '/images/plan-annotation/Misc/Shower-wall.svg';
SourcesMisc['Stone'] = '/images/plan-annotation/Misc/Stone.svg';
SourcesMisc['Wood'] = '/images/plan-annotation/Misc/Wood.svg';
SourcesMisc['Trees'] = '/images/plan-annotation/Misc/Trees.svg';
SourcesMisc['WallMountedWC'] = '/images/plan-annotation/Misc/Wall-mounted-WC.svg';
SourcesMisc['Wall'] = '/images/plan-annotation/Misc/Wall.svg';

DragSources['Misc'] = SourcesMisc;

// Outdoors

SourcesOutdoors['Balcony'] = '/images/plan-annotation/Outdoors/Balcony.svg';
SourcesOutdoors['Entrance'] = '/images/plan-annotation/Outdoors/Entrance.svg';
SourcesOutdoors['Fence'] = '/images/plan-annotation/Outdoors/Fence.svg';
SourcesOutdoors['FrenchBalcony'] = '/images/plan-annotation/Outdoors/French-balcony.svg';
SourcesOutdoors['GlassBalcony'] = '/images/plan-annotation/Outdoors/Glass-balcony.svg';
SourcesOutdoors['PoolRound'] = '/images/plan-annotation/Outdoors/Pool-round.svg';
SourcesOutdoors['Pool'] = '/images/plan-annotation/Outdoors/Pool.svg';

DragSources['Outdoors'] = SourcesOutdoors;

export const DragSVG = DragSources;
